export type KanbanTaskStatus = 'todo' | 'in-progress' | 'review' | 'done';

export interface KanbanTask {
  id: string;
  title: string;
  description?: string;
  status: KanbanTaskStatus;
  assignee?: string;
  priority?: 'low' | 'medium' | 'high' | 'urgent';
  tags?: string[];
  createdAt: number;
  updatedAt: number;
}

// Extract the shared seed data that multiple modules were reaching for
export const SEED_TASK_DETAILS: Record<string, KanbanTask> = {
  'task-1': {
    id: 'task-1',
    title: 'Finalize Jev CRM Fallback Heuristics',
    description: 'Ensure deterministic offline rules apply correctly.',
    status: 'done',
    assignee: 'herx',
    priority: 'high',
    tags: ['ai', 'core'],
    createdAt: Date.now() - 86400000,
    updatedAt: Date.now(),
  },
  'task-2': {
    id: 'task-2',
    title: 'Decouple UI Workspace Modules',
    description: 'Remove cross-module imports between chat, kanban, and shell.',
    status: 'in-progress',
    assignee: 'herx',
    priority: 'urgent',
    tags: ['frontend', 'architecture'],
    createdAt: Date.now(),
    updatedAt: Date.now(),
  },
  'task-3': {
    id: 'task-3',
    title: 'Deploy to Cloud Run',
    description: 'Integrate Secret Manager and finalize deployment.',
    status: 'done',
    assignee: 'herx',
    priority: 'high',
    tags: ['devops'],
    createdAt: Date.now() - 172800000,
    updatedAt: Date.now() - 86400000,
  }
};

// Contract definitions for state mutations (used later for microkernel events)
export interface UpdateTaskStatusPayload {
  taskId: string;
  newStatus: KanbanTaskStatus;
}
